import axios from "axios";
import { server } from "../../../../lib/server";

const jwtAxios = axios.create({
  baseURL: `${server}`, //YOUR_API_URL HERE
  // baseURL: "https://73fa-180-211-110-146.ngrok.io/", //YOUR_API_URL HERE
  headers: {
    "Content-Type": "application/json",
    Accept: "*/*",
  },
});
jwtAxios.interceptors.response.use(
  (res) => res,
  (err) => {
    if (err?.response?.status === 401) {
      window.location.href = "/logout";
    }
    return Promise.reject(err);
  }
);
export const setAuthToken = (token) => {
  if (token) {
    jwtAxios.defaults.headers.common["x-auth-token"] = token;
    localStorage.setItem("token", token);
  } else {
    delete jwtAxios.defaults.headers.common["x-auth-token"];
    localStorage.removeItem("token");
  }
};

export default jwtAxios;
